import angular from 'angular';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({});

/**
 * @ngdoc function
 * @name myConsultApp.controller:addressHistoryController
 * @description
 * # addressHistoryController
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller('addressHistoryController', ($ngRedux, $scope, $rootScope, $timeout, $http, ENV) => {
    $scope.init = () => {
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
    };

    $scope.clearAddressHistoryDetail = () => {
      $scope.isAddressHistoryActionMenu = false;
      $scope.addressHistoryTable = null;
      $scope.rescanConfirmation = false;
    };

    $scope.clearAddressHistoryDetail();

    $scope.close = () => {
      $rootScope.isAddressDisplay = false;
      $rootScope.closeComponent();
    };

    $scope.generateUserRoute = () => {
      return `${$rootScope.routes.user}/${$scope.user.id}`;
    };

    $scope.setTable = () => {
      $scope.addressHistoryTable = {
        name: 'Address History',
        options: {
          endpoint: '/2.0/users/' + $rootScope.userId + '/address-history/',
          endpoint_data_key: 'address-histories',
          id_prefix: 'addresshistory',
          per_page_options: [15, 25, 50, 100, 200],
          records_per_page: 15,
          row_style: 'standard',
          scale_up: true,
          search_key: 'Address History',
          search_required: false,
        },
        actions: [],
        columns: [
          {
            name: 'ID',
            options: {
              content: '{{ record.id }}',
              class: '',
            },
          },
          {
            name: 'Updated',
            options: {
              content: '{{ record.updated || "" }}',
              class: '',
            },
          },
          {
            name: 'Address Data',
            options: {
              content: '<div ng-if="record.address_data.first_name || record.address_data.last_name">{{ record.address_data.first_name }} {{ record.address_data.last_name }}</div>' + 
              '<div ng-if="record.address_data.address_street_address1">{{ record.address_data.address_street_address1 }}</div>' + 
              '<div ng-if="record.address_data.address_street_address2">{{ record.address_data.address_street_address2 }}</div>' + 
              '<div ng-if="record.address_data.address_city || record.address_data.address_state || record.address_data.zip || record.address_data.address_country">' +
              '{{ record.address_data.address_city }}<span ng-if="record.address_data.address_city && record.address_data.address_state">, </span>' + 
              '{{ record.address_data.address_state }} {{ record.address_data.zip }} {{ record.address_data.address_country }}</div>' + 
              '<div ng-if="record.address_data.email">{{ record.address_data.email }}</div>' + 
              '<div ng-if="record.address_data.mobile_phone">{{ record.address_data.mobile_phone }}</div>',
              class: '',
            },
          },
          {
            name: 'Address Changed',
            options: {
              content: '{{ record.address_changed ? "Changed" : "Not Changed" || "Not Changed" }}',
              class: '',
            },
          },

          {
            name: 'User Responsible',
            options: {
              content:
                '<span ng-if="record.user_responsible.first_name || record.user_responsible.last_name">' +
                '{{ record.user_responsible.first_name || "" }} {{ record.user_responsible.last_name || "" }}</span>' +
                '<br ng-if="(record.user_responsible.first_name || record.user_responsible.last_name) && record.user_responsible.contact_information.email"/>' +
                '<span ng-if="record.user_responsible.contact_information.email">' +
                '{{ record.user_responsible.contact_information.email || "" }}</span>',
              class: '',
            },
          },
          {
            name: 'USPS Validated',
            options: {
              content:
                '{{ record.usps_validated ? "Validated" : "Not Validated" || "Not Validated" }}',
              class: '',
            },
          },
        ],
        filters: [
          {
            name: 'Address Changed',
            type: 'multiple_choice',
            options: {
              choices: {
                Changed: { type: 'standard', state: true, value: 'true', order: 0 },
                'Not Changed': { type: 'standard', state: true, value: 'false', order: 1 },
              },
              class: '',
              query_string_parameter: 'address_changed',
              select_all: true,
            },
          },
          {
            name: 'USPS Validated',
            type: 'multiple_choice',
            options: {
              choices: {
                Validated: { type: 'standard', state: true, value: 'true', order: 0 },
                'Not Validated': { type: 'standard', state: true, value: 'false', order: 1 },
              },
              class: '',
              query_string_parameter: 'usps_validated',
              select_all: true,
            },
          },
          {
            name: 'Timeframe',
            type: 'single_choice',
            options: {
              choices: {
                'Last 24 Hours': { type: 'standard', state: false, value: 'day', order: 0 },
                'Previous Week': { type: 'standard', state: true, value: 'week', order: 1 },
                'Previous 365 Days': { type: 'standard', state: false, value: 'year', order: 2 },
                All: { type: 'standard', state: false, value: 'all', order: 3 },
                'Custom Range': {
                  type: 'range',
                  state: false,
                  value: 'range',
                  from: '',
                  to: '',
                  date_field: true,
                  order: 4,
                  error: false,
                },
              },
              class: 'timeframe-filter above-divider',
              query_string_parameter: 'timeframe',
            },
          },
        ],
        sort_options: {
          updated: {
            state: true,
            value: '-1',
            title: 'Updated',
            order: 0,
          },
          usps_validated: {
            state: false,
            value: '-1',
            title: 'USPS Validated',
            order: 1,
          },
        },
      };
    };

    const componentVisibleListener = $rootScope.$watch('componentOpened', () => {
      if (!$rootScope.componentOpened) {
        $scope.clearAddressHistoryDetail();
      }
    });

    const userIdListener = $rootScope.$watch('isAddressDisplay', () => {
      if ($rootScope.isAddressDisplay && $rootScope.userId) {
        $scope.setTable();
      } else {
        $scope.clearAddressHistoryDetail();
      }
    });

    $scope.init();

    $scope.$on('$destroy', () => {
      $scope.unsubscribe();
      componentVisibleListener();
      userIdListener();
    });
  })
  .directive('addressHistory', () => {
    return {
      templateUrl: 'templates/v2/address-history.html',
    };
  });
